import { render, staticRenderFns } from "./BilgiBoxes.vue?vue&type=template&id=4b833b84&scoped=true&"
import script from "./BilgiBoxes.vue?vue&type=script&lang=js&"
export * from "./BilgiBoxes.vue?vue&type=script&lang=js&"
import style0 from "./BilgiBoxes.vue?vue&type=style&index=0&id=4b833b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b833b84",
  null
  
)

export default component.exports